import type { AntonioInput } from '#src/types/antonio-step.ts';
import type { ChatMessage } from '#src/types/chat.ts';
import { BaseApiService } from './base-api.service';

export interface AntonioChatRequest {
	conversationId?: string;
	/** The step the input answers, as the server last named it. */
	stepKey: string;
	input: AntonioInput;
	/** The visitor's bubble for this turn, for inputs the transcript takes it from. */
	message?: ChatMessage;
	model: string;
	instance: string;
}

export class AntonioChatApiService extends BaseApiService {
	/** Every visitor input goes here; the server decides what happens next (see backend/routes/antonio_chat.go). */
	chat(request: AntonioChatRequest, signal?: AbortSignal) {
		return this.apiStream('POST', '/api/antonio-chat', request, {
			signal,
			dontThrowOnBadStatus: true
		});
	}

	/** Stores the visitor's own photo on the conversation, replacing an earlier one (see backend/routes/antonio_user_image.go). */
	uploadUserImage(conversationId: string, file: File): Promise<{ url: string }> {
		const formData = new FormData();
		formData.append('file', file);
		return this.apiFetch('POST', `/api/antonio-chat/${conversationId}/image`, formData);
	}

	retryChat(conversationId: string, signal?: AbortSignal) {
		return this.apiStream(
			'POST',
			`/api/antonio-chat/${conversationId}/retry`,
			{},
			{ signal, dontThrowOnBadStatus: true }
		);
	}
}
